import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../../common/common";

class CreateUserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: "",
      email: "",
      emailRequiredAlert: "",
      stateRolVoorUitvoering: false,
      rolVoorUitvoeringText: false,
      userRoles: [],
      userOrganization: [],
      selectOrganization: null,
      selectOrganizationId: null,
      roleForExecutionUser: [],
      roleForExecution: null,
      roleForExecutionId: null,
      roleForExecutionSelected: [
        "f2d5c526-20ae-4f5f-bd8c-b2100f9e142a",
        "7cd29e15-bb7c-4232-963d-1c44fbc4cd2d",
        "49bf5d8c-92b3-4b83-b384-1cf52876cabf",
      ],
      notSelected: [
        "413d4b93-f837-4bbd-9c1b-d12a28662999",
        "edbcb3db-fc9d-475c-965f-8d5f0d7f015c",
        "7571d177-862a-4bd0-8621-f6a6cfa600c2",
        "f2d5c526-20ae-4f5f-bd8c-b2100f9e142a",
        "7cd29e15-bb7c-4232-963d-1c44fbc4cd2d",
        "49bf5d8c-92b3-4b83-b384-1cf52876cabf",
      ],
      postRoles: [],
      emailAlert: false,
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEvent = this.handleEvent.bind(this);
  }

  handleEvent() {}

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ rolVoorUitvoeringText: false, postRoles: [] });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "email") {
      this.setState({ emailAlert: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    $("#cover-spin").show(0);

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });

    var emailValidation = new RegExp(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g
    ).test(this.state.email);
    this.state.email == "" || !emailValidation
      ? await this.setState({ emailAlert: true })
      : await this.setState({ emailAlert: false });

    let rolVoorUitvoering = {
      identification: this.state.roleForExecutionId,
      description: this.state.roleForExecution,
      name: this.state.roleForExecution,
      valid_from: "2020-09-15T09:16:19.531Z",
      is_organisation_administrator: false,
      is_administrator: true,
    };

    let roles = this.state.postRoles;

    if (this.state.rolVoorUitvoeringText) {
      roles.push(rolVoorUitvoering);
    }

    var model = {
      alias: this.state.naam,
      email: this.state.email,
      relationships: {
        own_organisation: {
          identification: this.state.selectOrganizationId, //process.env.REACT_APP_USER_OWN_ORGANISATION_ID,
          // identification: "a9fd1a52-edb8-4848-96e9-2741876cc9f1",
        },
        roles: [...roles],
      },
      profile: {},
      send_invitation: false,
    };
    if (
      this.state.naamRequiredAlert !== true &&
      this.state.emailAlert !== true
    ) {
      var data = await omnimap.CreateUserAction(
        model,
        window.$catalog_users_token
      );
      if (data.result.status === "OK") {
        CallBackFunctions.UserCreatedCallBack(window.$catalog_users_token);
      } else {
        alert(data.result.status);
        $("#cover-spin").hide(0);
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  /**
   * * service tarafından tüm roller burada çekilir
   * * ekrana yanıtılmayacak olan roller burada filtrelenir.
   */
  async getUserRoles() {
    let _userRoles = await omnimap.GetUserRolesAction(
      1,
      100,
      window.$catalog_users_token
    );

    var lastUserModel = [];
    var _roleForExecutionSelected = [];

    var selectedIds = [];
    for (let y = 0; y < _userRoles.data.length; y++) {
      const user = _userRoles.data[y];

      selectedIds.push(user.identification);
    }

    var difference = selectedIds.filter(
      (x) => this.state.notSelected.indexOf(x) === -1
    );

    for (let i = 0; i < _userRoles.data.length; i++) {
      const user = _userRoles.data[i];

      for (let j = 0; j < difference.length; j++) {
        const userNotSelected = difference[j];
        if (userNotSelected === user.identification) {
          let model = { name: user.name, id: user.identification };
          await lastUserModel.push(model);
          break;
        }
      }

      for (let w = 0; w < this.state.roleForExecutionSelected.length; w++) {
        const _roleForExecutionUser = this.state.roleForExecutionSelected[w];
        if (_roleForExecutionUser === user.identification) {
          let model = { name: user.name, id: user.identification };
          await _roleForExecutionSelected.push(model);
        }
      }
    }
    await this.setState({
      userRoles: lastUserModel,
      roleForExecutionUser: _roleForExecutionSelected,
      roleForExecution: _roleForExecutionSelected[0].name,
      roleForExecutionId: _roleForExecutionSelected[0].id,
    });
  }

  /**
   *
   */
  async getUserOrganisations() {
    let organisations = await omnimap.GetOrganisationsAction(
      1,
      100,
      window.$catalog_users_token
    );
    let data = [];
    for (let i = 0; i < organisations.data.length; i++) {
      const element = organisations.data[i];
      data.push({ id: element.identification, name: element.name });
    }
    this.setState({
      userOrganization: data,
      // selectOrganization: data[0].name,
      // selectOrganizationId: data[0].id,
    });
  }

  async handleRoleForExecutionUser(id, e) {
    const element = e.target;

    await this.setState({
      roleForExecution: element.name,
      roleForExecutionId: id,
    });
  }
  async handleOrganizitaion(id, e) {
    const element = e.target;

    await this.setState({
      selectOrganization: element.name,
      selectOrganizationId: id,
    });
  }

  /**
   * * bu fonksiyon checkbox ile sıralanmış rollerin seçilme durumuna göre
   * * ... statelerini değiştirir.
   * @param {seçilmiş olan checkbox'ın tüm verilerini alır} selectRole
   * @param {onClick() event attribute'lerini alır} event
   */
  async handleChecboxUser(selectRole, event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    if (value === true) {
      // post edilecek method
      let createModel = {
        identification: selectRole.id,
        description: selectRole.name,
        name: selectRole.name,
        valid_from: "2020-09-15T09:16:19.531Z",
        is_organisation_administrator: false,
        is_administrator: true,
      };
      let swap = this.state.postRoles;
      swap.push(createModel);
      this.setState({ postRoles: swap });
    } else {
      let swap = this.state.postRoles;
      /**
       * * seçilmiş veya seçimi kaldırılımış role burada filtrelenir
       */
      var _swap = await swap.filter((def) => {
        return def.identification !== selectRole.id;
      });
      await this.setState({ postRoles: _swap });
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#cat-user-add", function () {
      $("#add-user-modal").modal("show");
      that.resetForm();
      that.getUserRoles();
      that.getUserOrganisations();
    });
  }

  render() {
    this.handleEvent();

    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="add-user-modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Gebruiker toevoegen</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div class="user-create-input-content">
                <input
                  type="text"
                  className="user-create-input-user"
                  placeholder="Naam"
                  autocomplete="off"
                  name="naam"
                  value={this.state.naam}
                  onChange={this.handleInputChange.bind(this)}
                />
              </div>
              <div class="user-create-input-content">
                <label
                  className={
                    this.state.emailAlert
                      ? "modale-submit-alert-block"
                      : "modale-submit-alert-none"
                  }
                >
                  E-mailadres is defect
                </label>
                <input
                  type="email"
                  className="user-create-input-user-email"
                  placeholder="e-mail"
                  autocomplete="off"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleInputChange.bind(this)}
                />
              </div>

              <div className="modal-scroll">
                <label className="add-user-container role-text">
                  <div className="user-create-role-label organization-text">
                    Organisatie
                  </div>
                </label>

                <div
                  className={
                    this.state.stateRolVoorUitvoering
                      ? "user-create-input-content-role"
                      : "user-create-input-content-role"
                  }
                  onClick={() =>
                    this.setState({
                      stateRolVoorUitvoering:
                        !this.state.stateRolVoorUitvoering,
                    })
                  }
                >
                  <input
                    type="button"
                    className="user-create-input-dropdown"
                    placeholder="Naam"
                    autocomplete="off"
                    value={
                      this.state.selectOrganization !== null
                        ? this.state.selectOrganization
                        : ""
                    }
                  />
                  <div class="popup-dropdown">
                    <span
                      className={
                        this.state.stateRolVoorUitvoering
                          ? "popuptext-dropdown show rolvooruitvoering"
                          : "popuptext-dropdown"
                      }
                    >
                      {this.state.userOrganization.map((m) => (
                        <a
                          class="popuptext-dropdown-a"
                          name={m.name}
                          onClick={this.handleOrganizitaion.bind(this, m.id)}
                        >
                          {m.name}
                        </a>
                      ))}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-scroll">
                <label className="add-user-container role-text">
                  <div className="user-create-role-label role-text">
                    Rol voor uitvoering
                  </div>
                  <input
                    type="checkbox"
                    checked={this.state.rolVoorUitvoeringText ? true : false}
                    onClick={() =>
                      this.setState({
                        rolVoorUitvoeringText:
                          !this.state.rolVoorUitvoeringText,
                        stateRolVoorUitvoering: false,
                      })
                    }
                  />
                  <span className="add-user-checkmark" />
                </label>

                <div
                  className={
                    this.state.stateRolVoorUitvoering
                      ? "user-create-input-content-role"
                      : "user-create-input-content-role"
                  }
                  onClick={() =>
                    this.setState({
                      stateRolVoorUitvoering:
                        !this.state.stateRolVoorUitvoering,
                    })
                  }
                  style={
                    this.state.rolVoorUitvoeringText
                      ? {}
                      : { pointerEvents: "none", opacity: "0.5" }
                  }
                >
                  <input
                    type="button"
                    className="user-create-input-user-role"
                    placeholder="Naam"
                    autocomplete="off"
                    value={
                      this.state.roleForExecution !== null
                        ? this.state.roleForExecution
                        : ""
                    }
                  />
                  <div class="popup-dropdown">
                    <span
                      className={
                        this.state.stateRolVoorUitvoering
                          ? "popuptext-dropdown show rolvooruitvoering"
                          : "popuptext-dropdown"
                      }
                    >
                      {this.state.roleForExecutionUser.map((m) => (
                        <a
                          class="popuptext-dropdown-a"
                          name={m.name}
                          onClick={this.handleRoleForExecutionUser.bind(
                            this,
                            m.id
                          )}
                        >
                          {m.name}
                        </a>
                      ))}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-scroll">
                <label class="user-create-role-label">Gebruikersrollen</label>

                <div className="user-roles-content">
                  <div className="row clearfix user-roles">
                    {this.state.userRoles.map((m) => (
                      <div className="col-lg-6 text-center">
                        <label className="add-user-container">
                          <div className="add-user-container-title">
                            {m.name}
                          </div>
                          <input
                            type="checkbox"
                            onClick={this.handleChecboxUser.bind(this, m)}
                          />
                          <span className="add-user-checkmark" />
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/**
               * ileri status kullanılabilir
               */}
              {/* <div className="col-lg-4 text-center user-status">
                <div className="">
                  <div className="user-create-role-label">Status</div>
                  <label className="switch">
                    <input
                      id="e-beheereenheid_active"
                      type="checkbox"
                      defaultChecked={true}
                    />
                    <span className="slider-checkbox round" />
                  </label>
                </div>
              </div> */}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="save_beheereenheid"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateUserModal;
